module.exports = __webpack_public_path__ + "static/media/d10.208aea23.png";